/**
 * Proyecto: MOGOTAX-SERVER
 * Autor: Megatrack GPS SAS
 * Fecha de creación: 11 de noviembre 2024
 * Licencia: Propiedad Privada
 *
 * Este código es propiedad exclusiva de Megatrack GPS SAS & Mogotax SAS y no puede ser distribuido, copiado, modificado, publicado, sublicenciado ni comercializado sin el consentimiento expreso y por escrito de ambas empresa.
 *
 * Copyright (c) 2025 Megatrack GPS SAS. Todos los derechos reservados.
 */
import React from "react";

function FooterComponent() {
  return (
    <div
      className="footer"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px 20px",
        width: "100%",
        backgroundColor: "#001529",
        color: "white",
        position: "sticky",
        bottom: 0,
        zIndex: 1000,
      }}
    >
      <span>Copyright © 2024 Mogotax SAS. Todos los derechos reservados.</span>
    </div>
  );
}

export default FooterComponent;
